// 迁移至common/util/serverTime
import serverTime from 'root/common/util/serverTime';

export default serverTime;
